module.exports = __webpack_public_path__ + "img/meprint.276c563d.png";